export const ALIGNMENT_DATA_TYPE = {
  PAAF_BASIC: 'PAAF Basic',
  GUIDE_CLINICIAN: 'GUIDE Clinician',
  PAAF_CAREGIVER: 'PAAF Caregiver',
  PAAF_DEMENTIA: 'PAAF Dementia',
  PAAF_PATIENT: 'PAAF Patient',
  PAAF_UNALIGNMENT: 'PAAF Unalignment',
};

export const ALIGNMENT_DATA_CONFIG = {
  [ALIGNMENT_DATA_TYPE.PAAF_BASIC]: {
    fields: [
      { key: 'model_id', label: 'Model ID' },
      { key: 'entity_id', label: 'GUIDE Participant ID' },
      { key: 'assessment_date', label: 'Date of Assessment' },
      { key: 'assessment_type', label: 'Assessment Type' },
      { key: 'initial_patient', label: 'Initial Assessment Patient Type' },
      { key: 'pt_referral_source', label: 'Initial Assessment Patient Referral Source' },
      { key: 'reassessment_reason', label: 'Re-Assessment Reason' },
      { key: 'caregiver_status', label: 'Change in Caregiver Status' },
      { key: 'caregiver_status_os', label: 'Change in Caregiver Status - Other specify' },
      { key: 'tin', label: 'GUIDE Model Participant TIN' },
    ],
  },
  [ALIGNMENT_DATA_TYPE.GUIDE_CLINICIAN]: {
    fields: [
      { key: 'clinician_attestation', label: "Clinician's Attestation" },
      { key: 'clinician_first_name', label: 'First name' },
      { key: 'clinician_middle_name', label: 'Middle name' },
      { key: 'clinician_last_name', label: 'Last name' },
      { key: 'npi', label: 'NPI' },
    ],
  },
  [ALIGNMENT_DATA_TYPE.PAAF_CAREGIVER]: {
    fields: [
      { key: 'pcg_first_name', label: 'First Name' },
      { key: 'pcg_last_name', label: 'Last Name' },
      { key: 'pcg_email', label: 'Email Address' },
      { key: 'pcg_phone', label: 'Phone Number' },
      { key: 'pcg_phone_type', label: 'Type of Phone Number' },
      { key: 'pcg_date_of_birth', label: 'Date of Birth' },
      { key: 'pcg_sex', label: 'Sex' },
      { key: 'pcg_relationship', label: 'Relationship to Patient' },
      { key: 'pcg_residence', label: 'Residence' },
      { key: 'pcg_medicare_status', label: 'Medicare Status' },
      { key: 'pcg_mbi', label: 'MBI' },
      { key: 'zbi_score', label: 'ZBI Score' },
      { key: 'pcg_role_years', label: 'Role (Years)' },
      { key: 'pcg_role_months', label: 'Role (Months)' },
    ],
  },
  [ALIGNMENT_DATA_TYPE.PAAF_DEMENTIA]: {
    fields: [
      { key: 'staging_tool', label: 'Dementia Staging Tool Used' },
      { key: 'staging_score', label: 'Dementia Staging Tool Score' },
      { key: 'PROMIS_10_score', label: 'PROMIS-10 Score' },
      { key: 'patient_pcp', label: 'Patient Primary Care Provider (PCP)' },
    ],
  },
  [ALIGNMENT_DATA_TYPE.PAAF_PATIENT]: {
    fields: [
      { key: 'first_name', label: 'First Name' },
      { key: 'middle_initial', label: 'Middle Initial' },
      { key: 'last_name', label: 'Last Name' },
      { key: 'address_line', label: 'Street Address' },
      { key: 'address_city', label: 'City' },
      { key: 'address_state', label: 'State' },
      { key: 'address_postalCode', label: 'Zip Code' },
      { key: 'email', label: 'Email Address' },
      { key: 'phone', label: 'Phone Number' },
      { key: 'phone_type', label: 'Type of Phone Number' },
      { key: 'residence_type', label: 'Residence Type' },
      { key: 'not_nursing_home', label: 'Nursing Home Status' },
      { key: 'date_of_birth', label: 'Date of Birth' },
      { key: 'mbi', label: 'MBI' },
      { key: 'medicaid_id', label: 'Medicaid ID' },
    ],
  },
  [ALIGNMENT_DATA_TYPE.PAAF_UNALIGNMENT]: {
    fields: [
      { key: 'un_effective_date', label: 'Efective Date' },
      { key: 'unalignment_reason', label: 'Reason' },
    ],
  },
};

export const ALIGNMENT_DATA_OPTIONS = {
  PAAF_BASIC: { label: 'PAAF Basic', section: 'alignment-download' },
  GUIDE_CLINICIAN: { label: 'GUIDE Clinician', section: null },
  PAAF_CAREGIVER: { label: 'PAAF Caregiver', section: 'caregivers' },
  PAAF_DEMENTIA: { label: 'PAAF Dementia', section: 'scores' },
  PAAF_PATIENT: { label: 'PAAF Patient', section: 'info' },
  PAAF_UNALIGNMENT: { label: 'PAAF Unalignment', section: 'alignment-download' },
};
